import { useEffect, useState } from 'react';
import { getSubscriptionPrices } from '../services';

export const ANNUAL_PLAN_CODE = 'fffvipa';
export const SEASONAL_PLAN_CODE = 'fffvip';

export function useSubscriptionPrices() {
  const [seasonalPrice, setSeasonalPrice] = useState('');
  const [annualPrice, setAnnualPrice] = useState('');
  useEffect(() => {
    (async () => {
      const subscriptions = await getSubscriptionPrices();
      if (subscriptions) {
        setSeasonalPrice(subscriptions[SEASONAL_PLAN_CODE]?.price?.amount);
        setAnnualPrice(subscriptions[ANNUAL_PLAN_CODE]?.price?.amount);
      }
    })();
  }, []);

  return { seasonalPrice, annualPrice };
}
